var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.value),function(value,label,index){return _c('div',{key:index},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(label),expression:"label"}]},[_vm._v("1 x "+_vm._s(value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }